import { all, put, takeEvery } from "redux-saga/effects";

import { rollbarXHRError } from "lib/rollbar";
import { get } from "redux/fetch";
import applicationSagas from "redux/applications/sagas";
import positionSagas from "redux/positions/sagas";
import questionSagas from "redux/questions/sagas";
import { uiSetLoading } from "redux/ws/actions";

import { candidateFetchProfile, candidateSetProfileData } from "redux/candidate/actions";

function* fetchProfile() {
    yield put(uiSetLoading(true));

    try {
        const profile = yield get("/api/v1/profile/");
        yield put(candidateSetProfileData(profile));
    } catch (e) {
        rollbarXHRError("Failed to fetch candidate profile", e);
    } finally {
        yield put(uiSetLoading(false));
    }
}

export default function* candidateSagas() {
    yield all([
        applicationSagas(),
        positionSagas(),
        questionSagas(),
        takeEvery(candidateFetchProfile, fetchProfile),
    ]);
}
